import Image from 'next/image'
import {FC} from 'react'

import {theme} from '@/theme/theme'
import {MOBILE_SCREENSIZE} from '@/utils/styles/breakpoints'

import {Text, TextFontWeight, TextVariant} from '../content/Text'

type ImageChipProps = {title: string; imageSrc: string; imageAlt: string; backgroundColor?: string}

export const ImageChip: FC<ImageChipProps> = ({
  title,
  imageSrc,
  imageAlt,
  backgroundColor = theme.palette.background.butter,
}) => (
  <>
    <div className="wrapper">
      <div className="icon">
        <Image
          src={imageSrc}
          alt={imageAlt}
          style={{objectFit: 'contain'}}
          width={28}
          height={28}
        />
      </div>
      <Text variant={TextVariant.text14} fontWeight={TextFontWeight.bold} align="left">
        {title}
      </Text>
    </div>

    <style jsx>{`
      .wrapper {
        display: flex;
        align-items: center;
        gap: ${theme.spacing[3]};
        padding-right: ${theme.spacing[3.5]};
        background-color: ${backgroundColor};
        border-radius: 24px;
      }
      .icon {
        display: flex;
        align-items: center;
        justify-content: center;
        width: 48px;
        height: 48px;
        flex: 0 0 48px;
        background-color: ${backgroundColor};
        border-radius: 50%;
        border: 4px solid ${theme.palette.background.default};
      }
      @media ${MOBILE_SCREENSIZE} {
        .wrapper {
          width: 100%;
          gap: ${theme.spacing[2.5]};
          padding-right: ${theme.spacing[3]};
        }
      }
    `}</style>
  </>
)
